import React, { useState } from 'react';
import VaultTabs, { VaultTabKey } from './VaultTabs';
import VaultNetBody from './VaultNetBody';

const VaultView: React.FC = () => {
    const [activeTab, setActiveTab] = useState<VaultTabKey>('sops');

    return (
        <div className="module-page">
            <VaultTabs activeTab={activeTab} onTabChange={setActiveTab} />
            <VaultNetBody activeTab={activeTab} />
        </div>
    );
};

export default VaultView;
